export default __webpack_public_path__ + "static/media/kasapuram.c9a18d9c.png";